module.exports = __webpack_public_path__ + "static/Rocky Mountain_finalLOGO-01-49ae75e0ed7dfe8537986c747dc05e8d.png";